var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useEffect, useState } from "react";
import layoutComponentsDictionary from "../../layout/layoutComponentsDictionary";
import { FormSettingsContext } from "../../utils";
import WidgetSelectorStudio from "@/components/widgets/selector/widgetSelectorStudio";
import { useTranslation } from "react-i18next";
/**
 * Header edit component
 *
 * @param param0
 */
export function EtcWidgetSettings(_a) {
    var isStudioField = _a.isStudioField, layoutType = _a.layoutType, meta = _a.meta;
    var _b = useContext(FormSettingsContext), settings = _b.settings, editedSettings = _b.editedSettings;
    var t = useTranslation().t;
    var _c = useState({
        id: "",
        type: "",
        payload: {},
        mode: "add",
        slot: null, // "add" or "edit"
    }), selector = _c[0], setSelector = _c[1];
    useEffect(function () {
        var c = settings.component || {};
        var s = c.settings || {};
        var w = s.widget || {};
        setSelector({
            id: w.id,
            type: w.type,
            payload: __assign({}, w.payload),
            mode: "edit",
            slot: null,
        });
    }, [settings]);
    var updateWidgetSelected = function (widget) {
        editedSettings(__assign(__assign({}, settings), { component: {
                id: widget.id,
                type: "etc-widget",
                settings: { widget: widget },
            }, currentComponent: {
                id: widget.id,
                type: "etc-widget",
                settings: { widget: widget },
            }, newLayout: settings.newLayout, isDirty: true, isEtcWidget: true }));
    };
    return (_jsx(_Fragment, { children: _jsx("div", { children: _jsxs("div", __assign({ className: "" }, { children: [_jsx("label", __assign({ className: " ml-2 text-[rgb(var(--color-gray-400))]" }, { children: t("app.LBL_WIDGET_SELECT", { ns: "common" }) })), _jsx(WidgetSelectorStudio, { widget: selector, layout: "detail", setSelected: updateWidgetSelected })] })) }) }));
}
layoutComponentsDictionary.registerLayoutComponent("etc-widget-settings", EtcWidgetSettings);
